
import { authorizeMe, axiosInstance} from './commonHeadApiLogic.js';

// Ensure authorization header is set before making authenticated requests
const withAuthorization = async (apiFunction, ...args) => {
  try {
    await authorizeMe(); // Ensure the Authorization header is set
    return await apiFunction(...args);
  } catch (error) {
    // Handle errors as necessary
    console.error("Error in API request:", error);
    throw error;
  }
};

export const AddPhotographerAPI = (payload) => {
  return withAuthorization(async () => {
    return axiosInstance.post(
      `/api/admins/photographers/unverified`,
      payload
    );
  });
};


export const UpdateUnverifiedPhotographerAPI = (id, payload) => {
  return withAuthorization(async () => {
    return axiosInstance.put(
      `/api/admins/photographers/unverified/${id}`,
      payload
    );
  });
};

export const DeleteUnverifiedPhotographerAPI = (id) => {
  return withAuthorization(async () => {
    return axiosInstance.delete(
      `/api/admins/photographers/unverified/${id}`
    );
  });
};



export async function getUnverifiedPhotographersAPI(page = 1,LIMIT) {
  return withAuthorization(async () => {
    // return axiosInstance.get(`/api/admins/photographers/unverified?page=${page}&limit=${LIMIT}`);
    return axiosInstance.get(`/api/admins/photographers?page=${page}&limit=${LIMIT}&status=pending`);

  });
}

export async function getVerifiedPhotographersAPI(page = 1,LIMIT) {
  return withAuthorization(async () => {
    return axiosInstance.get(`/api/admins/photographers?page=${page}&limit=${LIMIT}&status=active,inactive`);
  });
}

// /api/admins/servicename
export async function getServicesAPI() {
  return withAuthorization(async () => {
    return axiosInstance.get(`/api/admins/servicename`);
  });
}

export const GetPhotographerProfileAPI = (id) => {
  return withAuthorization(async () => {
    return axiosInstance.get(
      `/api/admins/photographers/profile/${id}`
    );
  });
};

export const UpdatePhotographerProfileAPI = (id, payload) => {
  return withAuthorization(async () => {
    return axiosInstance.post(
      `/api/admins/photographers/profile/${id}`,
      payload
    );
  });
};



export const VerifyPhotographerAPI = (id, payload) => {
  return withAuthorization(async () => {
    return axiosInstance.post(
      `/api/admins/photographers/verify/${id}`,
      payload
    );
  });
};

// RATINGS & FEEDBACK
export const givePhotographerRatingAPI = (payload) => {
  return withAuthorization(async () => {
    return axiosInstance.post("/api/admins/giveRating", payload);
  });
};


export const SendPhotographerOTPAPI = (payload) => {
  return withAuthorization(async () => {
    return axiosInstance.post(
      `/api/admins/verify/sendOTP`,
      payload
    );
  });
};

export const VerifyPhotographerOTPAPI = (payload) => {
  return withAuthorization(async () => {
    return axiosInstance.post(
      `/api/admins/verify/verifyOTP`,
      payload
    );
  });
};


export const getAdminRatingAPI = () => {
    return withAuthorization(async () => {
    return axiosInstance.get(`/api/admins/getAdminRating`);
  });
};

